module.exports = __webpack_public_path__ + "img/icon45.c2966949.png";